export var EStepTransitionStatus;

(function (EStepTransitionStatus) {
  EStepTransitionStatus["Ready"] = "ready";
  EStepTransitionStatus["Boundary"] = "boundary";
  EStepTransitionStatus["Error"] = "error";
})(EStepTransitionStatus || (EStepTransitionStatus = {}));